// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2Qm7OG3hQRLT4x9Z25pDQ9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/wrapper/wrapper.scss
// module id = 458
// module chunks = 0